const DIFFERENTIALS = [
  {
    title: "Atendimento Humanizado",
    description:
      "Cada cliente é único e merece atenção personalizada. Ouvimos sua história com empatia e trabalhamos para encontrar a melhor solução para o seu caso, sempre com respeito e cuidado.",
  },
  {
    title: "Clareza na Comunicação",
    description:
      "Sem juridiquês. Explicamos tudo em linguagem simples para que você entenda cada passo do processo, saiba o que esperar e tome decisões com segurança e confiança.",
  },
  {
    title: "Acompanhamento Completo",
    description:
      "Estamos ao seu lado do início ao fim. Do protocolo da documentação até a conquista do benefício, acompanhamos cada fase com transparência e dedicação total.",
  },
  {
    title: "Agilidade nos Resultados",
    description:
      "Sabemos que tempo é essencial quando se trata de benefícios que garantem seu sustento. Por isso, agimos com eficiência e determinação para resolver seu caso no menor tempo possível.",
  },
  {
    title: "Ética e Transparência",
    description:
      "Atuamos com total conformidade às normas da OAB. Você receberá informações honestas sobre as chances reais do seu caso, sem promessas vazias.",
  },
  {
    title: "Atendimento Online e Presencial",
    description:
      "Atendemos em todo o Brasil de forma online, com total comodidade para você. Sem precisar sair de casa, você tem acesso a uma defesa jurídica de excelência.",
  },
];

export default function Differentials() {
  return (
    <section id="diferenciais" className="w-full py-28 px-6" style={{ backgroundColor: "#FAF7F3" }}>
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="font-body text-peach text-xs tracking-[0.35em] uppercase font-medium mb-4">
            Por que nos escolher
          </p>
          <h2
            className="font-display text-4xl lg:text-5xl font-semibold leading-tight mb-4"
            style={{ color: "rgb(61, 35, 32)" }}
          >
            Nossos{" "}
            <span className="font-light italic" style={{ color: "rgb(61, 35, 32)" }}>
              Diferenciais
            </span>
          </h2>
          <div className="w-10 h-px bg-peach mx-auto mt-6 mb-7" />
          <p
            className="font-body text-base max-w-xl mx-auto leading-relaxed"
            style={{ color: "rgba(61, 35, 32, 0.55)" }}
          >
            O que faz do Martins Advocacia a escolha certa para defender os seus direitos previdenciários.
          </p>
        </div>

        {/* Grid — desktop */}
        <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {DIFFERENTIALS.map((item, idx) => (
            <div
              key={item.title}
              className="rounded-2xl p-8 border transition-all duration-300 hover:-translate-y-1"
              style={{
                backgroundColor: "#ffffff",
                borderColor: "#EBE3D8",
              }}
            >
              {/* Number */}
              <span
                className="font-display text-5xl font-bold leading-none select-none block mb-6"
                style={{ color: "rgba(61, 35, 32, 0.08)" }}
              >
                {String(idx + 1).padStart(2, "0")}
              </span>

              <h3
                className="font-display text-base font-semibold mb-3 leading-snug"
                style={{ color: "rgb(61, 35, 32)" }}
              >
                {item.title}
              </h3>
              <p
                className="font-body text-sm leading-relaxed"
                style={{ color: "rgba(61, 35, 32, 0.55)" }}
              >
                {item.description}
              </p>
            </div>
          ))}
        </div>

        {/* Mobile Carousel */}
        <div
          className="flex md:hidden gap-4 overflow-x-auto pb-4 snap-x snap-mandatory scroll-smooth"
          style={{ scrollPaddingLeft: "20px", WebkitOverflowScrolling: "touch" } as React.CSSProperties}
        >
          {DIFFERENTIALS.map((item, idx) => (
            <div
              key={item.title}
              className="rounded-2xl p-7 snap-center flex-shrink-0 border"
              style={{
                width: "82vw",
                maxWidth: "340px",
                backgroundColor: "#ffffff",
                borderColor: "#EBE3D8",
              }}
            >
              <span
                className="font-display text-5xl font-bold leading-none select-none block mb-6"
                style={{ color: "rgba(61, 35, 32, 0.08)" }}
              >
                {String(idx + 1).padStart(2, "0")}
              </span>
              <h3
                className="font-display text-base font-semibold mb-3 leading-snug"
                style={{ color: "rgb(61, 35, 32)" }}
              >
                {item.title}
              </h3>
              <p
                className="font-body text-sm leading-relaxed"
                style={{ color: "rgba(61, 35, 32, 0.55)" }}
              >
                {item.description}
              </p>
            </div>
          ))}
          <div className="flex-shrink-0 w-4" />
        </div>
      </div>
    </section>
  );
}
